import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Spin } from "antd";
import Navbar from "./components/navbar/Navbar";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import ChangePassword from "./pages/change-password/ChangePassword";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import FloatingButton from "./components/floatingButton/FloatingButton";
import Footer from "./components/footer/Footer";
import "./App.css";
import Signup from "./pages/signup/Signup";
import Universe from "./pages/universe/Universe";
import EditorOrganizations from "./pages/editor-organizations/EditorOrganizations";
import DpoMyChecklist from "./pages/dpo-my-checklist/DpoMyChecklist";
import MyTasks from "./pages/my-tasks/MyTasks";
import Reports from "./pages/reports/Reports";
import AuditPage from "./pages/audit-page/AuditPage";
import DocumentRepo from "./pages/document-repo/DocumentRepo";
import ConfigPage from "./pages/config-page/ConfigPage";
import NoPermissionsPage from "./pages/no-permissions/NoPermissions";
import "./styles/antd_vars.css";
import ResetPassword from "./pages/reset-password/ResetPassword";
import { isEmpty, isNil } from "lodash";
import { instance } from "./store/utils";
import { accountCheckerUser, logoutUser } from "./store/user/actions";
import {
  fetchOrganizationsByUser,
  fetchUsersData
} from "./store/organizations/actions";
import { getAllMessages, getObligationsByUserAndOrg } from "./store/obligations/actions";
import { getLawsByUserAndOrg } from "./store/laws/actions";
import { getInternalObligationsByUserAndOrg } from "./store/internalObligations/actions";
import { getAppConfig } from "./store/forms/actions";
import { Home, Internal, LoginRoute, PrivateRoute } from "./routes/Routes";
import { getMetaCsrf, setMetaCsrf } from "./util/basicRenders";

function App() {
  const dispatch = useDispatch();
  const appConfig = useSelector(state => state.forms.appConfig);
  const user = useSelector(state => state.user);
  const organizations = useSelector(state => state.organizations.organizations);
  const organizationId = useSelector(
    state => state.organizations.organizationId
  );
  const [metaCsrf, setAppMetaCsrf] = useState(getMetaCsrf() || '');

  const [userLoading, setUserLoading] = useState(true);
  const visibleSeeLess = useSelector(
    state => state.recordTables?.seeLess?.visible
  );
  const target = useSelector(state => state.recordTables?.seeLess?.goTo);

  useEffect(() => {
    instance
      .get("/api/user/protect", {
        headers: {
          "Cache-Control": "no-cache"
        }
      })
      .then(response => {
        // console.debug(response)
        let token = response?.data;
        setMetaCsrf(token);
        setAppMetaCsrf(token);
      }).catch((err) => console.error("user/protect:", err?.response?.data));

    instance
      .get("/api/user/accountChecker", {
        headers: {
          "Cache-Control": "no-cache"
        }
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(accountCheckerUser(response));
        }
      })
      .catch(() => {
        dispatch(logoutUser);
        setUserLoading(false);
      });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!window.location.href.includes("/login")) {
        instance
          .get("/api/user/accountChecker", {
            headers: {
              "Cache-Control": "no-cache"
            }
          })
          .then(response => {})
          .catch(error => {
            dispatch(logoutUser());
            setUserLoading(false);
          });
      }
    }, 600000); // 10 minutes interval
    const interval2 = setInterval(() => {
      if (window.location.href.includes("/login")) {
        instance
          .get("/api/user/protect", {
            headers: {
              "Cache-Control": "no-cache"
            }
          })
          .then(response => {
            // console.debug(response)
            let token = response?.data;
            setMetaCsrf(token);
            setAppMetaCsrf(token);
          }).catch((err) => console.error("user/protect:", err?.response?.data));;
      }
    }, 300000); // 5 minutes interval to refresh csrf token/cookie
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(user)) {
      dispatch(getAppConfig({ callback: () => setUserLoading(false) }));
      dispatch(fetchOrganizationsByUser(user.userId));
    }
  }, [user]);

  useEffect(() => {
    if (user.role === "masterEditor") {
      dispatch(getObligationsByUserAndOrg(user, ""));
      dispatch(getLawsByUserAndOrg(user, ""));
    } else if (!isEmpty(organizations)) {
      dispatch({
        type: "SET_SELECTED_ORGANIZATION_ID",
        payload: organizations[0]._id
      });
    }
  }, [organizations]);

  useEffect(() => {
    if (!isNil(organizationId)) {
      dispatch(fetchUsersData(user, organizationId));
      dispatch(getLawsByUserAndOrg(user, organizationId));
      dispatch(getObligationsByUserAndOrg(user, organizationId));
      dispatch(getAllMessages(user, organizationId));     //error when changing organization
      dispatch(getInternalObligationsByUserAndOrg(user, organizationId));
      dispatch({
        type: "UPDATE_ORG_INT_CATEGORIES_SUCCESS",
        payload:
          organizations?.find(item => item._id === organizationId)
            ?.categories ?? []
      });
    }
  }, [organizationId]);

  return (
    <div className={`App${!user ? " login-page" : ""}`}>
      {userLoading ||
      (!isEmpty(user) && isEmpty(appConfig)) ||
      isEmpty(metaCsrf) ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginLeft: "755px",
            marginTop: "50px"
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <BrowserRouter basename="/regcom">
          {<Navbar className="sticky-navbar" />}
          <div className={`main-content${!user ? " login-page" : ""}`}>
            {/* !! this floating button is here because fixed and sticky positions don't work inside transformed components */}
            {visibleSeeLess && (
              <FloatingButton
                // icon={<FileTextOutlined />}
                target={target ?? ""}
                description="Show Less"
              />
            )}
            <div className={`pages${!user ? " login-page" : ""}`}>
              <Routes>
                <Route
                  path="/home-page"
                  element={<Home user={user} config={appConfig} />}
                />

                <Route
                  path="/organizations"
                  element={
                    <PrivateRoute
                      Component={EditorOrganizations}
                      page="organizations"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/config-page"
                  element={
                    <PrivateRoute
                      Component={ConfigPage}
                      page="config-page"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/regulatory-universe"
                  element={
                    <PrivateRoute
                      Component={Universe}
                      page="regulatory-universe"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/my-tasks"
                  element={
                    <PrivateRoute
                      Component={MyTasks}
                      page="my-tasks"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/doc-repo"
                  element={
                    <PrivateRoute
                      Component={DocumentRepo}
                      page="doc-repo"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/internal-obligations"
                  element={<Internal user={user} config={appConfig} />}
                />

                <Route
                  path="/my-checklist"
                  element={
                    <PrivateRoute
                      Component={DpoMyChecklist}
                      page="my-checklist"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/audit"
                  element={
                    <PrivateRoute
                      Component={AuditPage}
                      page="audit"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/reports"
                  element={
                    <PrivateRoute
                      Component={Reports}
                      page="reports"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/login"
                  element={<LoginRoute user={user} config={appConfig} />}
                />

                <Route
                  path="/signup"
                  element={
                    <PrivateRoute
                      Component={Signup}
                      page="signup"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/no-permissions"
                  element={
                    <PrivateRoute
                      Component={NoPermissionsPage}
                      page="no-permissions"
                      user={user}
                      config={appConfig}
                    />
                  }
                />

                <Route
                  path="/forgot-password"
                  element={
                    !isEmpty(user) ? <ForgotPassword /> : <ForgotPassword />
                  }
                />
                <Route
                  path="/change-password"
                  // element={!user ? <ChangePassword /> : <ChangePassword />}
                  element={<ChangePassword />}
                />

                <Route path="/reset-password" element={<ResetPassword />} />

                {/* if all else fails. maybe add "page not found" page later */}
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </div>
            {isEmpty(user) && <Footer login={true} />}
            {!isEmpty(user) && <Footer login={false} />}
          </div>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
